import { ChannelMember } from '@src/api/shared/community/channelMemberApiClient';
import { Attachment } from '@src/idb';
import { TiptapEditorHandle } from '@src/ui/Editor';
import { CommunityTiptapEditor } from '@src/ui/templates/Shared/CommunityTiptapEditor/CommunityTiptapEditor';
import { forwardRef } from 'react';

interface ThreadInputProps {
  channelCode: string;
  channelName: string;
  channelMembers: ChannelMember[];
  channelVisibility?: number;
  message: string;
  attachments: Attachment[];
  isAnonymous: boolean;
  isEditing: boolean;
  editedChatId?: number;
  allowFileAttachment: boolean;
  allowAnonymousPost: boolean;
  viewportHeight: number;
  isInitFocus?: boolean;
  parentChatId?: number;
  isLoggedIn?: boolean;
  onMessageChange: (message: string) => void;
  onAttachmentChange: (attachments: Attachment[]) => void;
  onChangeIsAnonymous: (isAnonymous: boolean) => void;
  onSend: () => void;
  onCancelEdit: () => void;
  className?: string;
}

const ThreadInput = forwardRef<TiptapEditorHandle, ThreadInputProps>(
  (
    {
      channelCode,
      channelName,
      channelMembers,
      channelVisibility,
      message,
      attachments,
      isAnonymous,
      isEditing,
      editedChatId,
      allowFileAttachment,
      allowAnonymousPost,
      viewportHeight,
      isInitFocus = false,
      parentChatId,
      isLoggedIn = true,
      onMessageChange,
      onAttachmentChange,
      onChangeIsAnonymous,
      onSend,
      onCancelEdit,
      className = '',
    },
    ref,
  ) => {
    return (
      <div
        className={`relative z-10 shrink-0 bg-white px-2 py-3 lg:px-4 lg:pb-5 lg:pt-3 lg:[&_.toolbar]:hidden ${className}`}
      >
        <div
          className='touch-pan-y overflow-y-auto overscroll-contain'
          style={{ maxHeight: `${viewportHeight * 0.5}px`, WebkitOverflowScrolling: 'touch' }}
        >
          <CommunityTiptapEditor
            ref={ref}
            value={message}
            onChange={onMessageChange}
            onSend={onSend}
            attachments={attachments}
            onAttachmentChange={onAttachmentChange}
            enabled={{
              richText: true,
              mentions: true,
              images: true,
              links: true,
              tables: false,
              iframes: false,
              textStyles: true,
              lists: true,
              codeBlocks: false,
              quotes: true,
              dividers: false,
              history: true,
              dragDrop: false,
              fileUpload: false,
              fileSave: false,
              shortcut: {
                underline: false,
                strike: true,
                heading: false,
                textAlign: false,
                blockquote: true,
              },
            }}
            height='100%'
            width='100%'
            containerHeight='100%'
            channelCode={channelCode}
            channelName={channelName}
            channelMembers={channelMembers}
            channelVisibility={channelVisibility}
            isAnonymous={isAnonymous}
            onChangeIsAnonymous={onChangeIsAnonymous}
            isEditing={isEditing}
            editedChatId={editedChatId}
            allowFileAttachment={allowFileAttachment}
            allowAnonymousPost={allowAnonymousPost}
            onCancelEdit={onCancelEdit}
            isInitFocus={isInitFocus}
            isLoggedIn={isLoggedIn}
            placeholderText='返信する'
            parentChatId={parentChatId}
          />
        </div>
      </div>
    );
  },
);

ThreadInput.displayName = 'ThreadInput';

export default ThreadInput;
